/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { TechScreenMonitorIcon16Light } from './TechScreenMonitorIcon16Light';
import { TechScreenMonitorIcon16Regular } from './TechScreenMonitorIcon16Regular';
import { TechScreenMonitorIcon16Solid } from './TechScreenMonitorIcon16Solid';
import { TechScreenMonitorIcon20Light } from './TechScreenMonitorIcon20Light';
import { TechScreenMonitorIcon20Regular } from './TechScreenMonitorIcon20Regular';
import { TechScreenMonitorIcon20Solid } from './TechScreenMonitorIcon20Solid';
import { TechScreenMonitorIcon24Regular } from './TechScreenMonitorIcon24Regular';
import { TechScreenMonitorIcon24Solid } from './TechScreenMonitorIcon24Solid';
import { TechScreenMonitorIcon32Regular } from './TechScreenMonitorIcon32Regular';
import { TechScreenMonitorIcon64Regular } from './TechScreenMonitorIcon64Regular';
var sizes = {
    16: {
        light: TechScreenMonitorIcon16Light,
        regular: TechScreenMonitorIcon16Regular,
        solid: TechScreenMonitorIcon16Solid,
    },
    20: {
        light: TechScreenMonitorIcon20Light,
        regular: TechScreenMonitorIcon20Regular,
        solid: TechScreenMonitorIcon20Solid,
    },
    24: {
        regular: TechScreenMonitorIcon24Regular,
        solid: TechScreenMonitorIcon24Solid,
    },
    32: {
        regular: TechScreenMonitorIcon32Regular,
    },
    64: {
        regular: TechScreenMonitorIcon64Regular,
    },
};
export var TechScreenMonitorIcon = forwardRef('TechScreenMonitorIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
